import React, { useState, useEffect } from 'react';
import './style/Home.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import config from './config/config';

function CarSelectorPageModal() {
    const navigate = useNavigate();

    const [brands, setBrands] = useState([]);
    const [models, setModels] = useState([]);
    const [years, setYears] = useState([]);

    const [selectedBrand, setSelectedBrand] = useState('');
    const [selectedModel, setSelectedModel] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedModelId, setSelectedModelId] = useState(null);
    const [selectedBrandId, setSelectedBrandId] = useState(null);

    useEffect(() => {
        const fetchBrands = async () => {
            try {
                const response = await fetch(`${config.apiUrl2}/api/auto/brands`, {
                    method: 'GET',
                    headers: { 'User-Agent': 'insomnia/11.2.0' }
                });

                if (!response.ok) throw new Error('Ошибка загрузки брендов');

                const data = await response.json();
                setBrands(data);
            } catch (error) {
                console.error('❌ Ошибка при загрузке брендов:', error);
            }
        };

        fetchBrands();
    }, []);

    const handleBrandChange = async (brandName) => {
        const brand = brands.find(b => b.name === brandName);
        setSelectedBrand(brandName);
        setSelectedBrandId(brand?.id || null);
        setSelectedModel('');
        setSelectedYear('');
        setYears([]);

        if (brand?.id) {
            try {
                const response = await fetch(`${config.apiUrl2}/api/auto/models-in-brand/${brand.id}`, {
                    method: 'GET',
                    headers: { 'User-Agent': 'insomnia/11.2.0' }
                });

                if (!response.ok) throw new Error('Ошибка при загрузке моделей');

                const data = await response.json();
                setModels(data);
            } catch (error) {
                console.error('❌ Ошибка при загрузке моделей:', error);
                setModels([]);
            }
        }
    };



    const handleModelChange = async (modelName) => {
        setSelectedModel(modelName);
        setSelectedYear('');

        const selectedModelObj = models.find((model) => model.name === modelName);
        if (!selectedModelObj?.id) return;

        setSelectedModelId(selectedModelObj.id);

        try {
            const response = await fetch(`${config.apiUrl2}/api/auto/years-model-id/${selectedModelObj.id}`, {
                method: 'GET',
                headers: {
                    'User-Agent': 'insomnia/11.2.0'
                }
            });

            if (!response.ok) throw new Error('Ошибка загрузки годов по модели');

            const data = await response.json(); // массив объектов с year и price
            setYears(data); // сохраняем весь объект, чтобы цену позже получить
        } catch (error) {
            console.error('❌ Ошибка при загрузке годов:', error);
            setYears([]);
        }
    };



    const handleNextCarInfo = () => {
        if (!selectedBrand || !selectedModel || !selectedYear) {
            alert('Пожалуйста, выберите все параметры автомобиля!');
            return;
        }

        const selectedYearObj = years.find((y) => String(y.year) === String(selectedYear));
        const price = selectedYearObj?.price ?? 'Цена не указана';
        const yearId = selectedYearObj?.idYear;

        navigate('/cars-info-block', {
            state: {
                brand: selectedBrand,
                brandId: selectedBrandId,
                model: selectedModel,
                modelId: selectedModelId,
                year: parseInt(selectedYear, 10),
                yearId,
                price,
            },
        });
    };


    const sliderSettings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
    };

    return (
        <div className="home hightech-theme">
            <motion.section
                className="car-selector"
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
            >
                <h2>🚗 Выберите ваш автомобиль</h2>
                <div className="select-group">
                    <motion.select
                        value={selectedBrand}
                        onChange={(e) => handleBrandChange(e.target.value)}
                        whileFocus={{ scale: 1.02 }}
                    >
                        <option value="">Марка автомобиля</option>
                        {brands.map((brand) => (
                            <option key={brand.id} value={brand.name}>{brand.name}</option>
                        ))}
                    </motion.select>

                    <motion.select
                        value={selectedModel}
                        onChange={(e) => handleModelChange(e.target.value)}
                        disabled={!selectedBrandId}
                        whileFocus={{ scale: 1.02 }}
                    >
                        <option value="">Модель</option>
                        {models.map((model) => (
                            <option key={model.id} value={model.name}>{model.name}</option>
                        ))}
                    </motion.select>

                    <motion.select
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                        disabled={years.length === 0}
                        whileFocus={{ scale: 1.02 }}
                    >
                        <option value="">Год выпуска</option>
                        {years.map((item) => (
                            <option key={item.idYear} value={item.year}>
                                {item.year}
                            </option>
                        ))}
                    </motion.select>


                    <motion.button
                        onClick={handleNextCarInfo}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                    >
                        Дальше
                    </motion.button>
                </div>
            </motion.section>

        </div>
    );
}

export default CarSelectorPageModal;
